const allowedTracingUrlsRegex = /https?:\/\/(?!refer\.)([a-zA-Z0-9-]+\.)*booksy\.(com|pm)/

export default allowedTracingUrlsRegex
